export const FORM_ERROR_MESSAGES = {
  fieldRequierd: 'Éste campo es obligatorio',
  invaildEmail: 'La dirección de email es inválida',
  atLeastOneOptionSelected: 'Se requiere al menos una opción seleccionada',
};
